import * as React from 'react';
//import Spinner from 'react-bootstrap/Spinner';
import "./LoadMessage.css";
import logoLoading from '../assets/images/logo-loading.gif'
import {Image} from "react-bootstrap";
import {Tooltip} from "antd";

function LoadMessage({message, title, height}) {
  return (
    <div className="loading-container">
      <div className="loading-animation">
        <svg viewBox="0 0 100 100" fill="none">
          {/* Glowing Sphere with Swirling Light */}
          <g className="glowing-sphere">
            {/* Sphere outline */}
            <circle className="sphere-outline" cx="50" cy="50" r="35" fill="none" stroke="#6B54F9" strokeWidth="1" opacity="0.8"/>
            
            {/* Central bright point */}
            <circle className="central-glow" cx="50" cy="55" r="3" fill="#FFFFFF" opacity="0.9"/>
            
            {/* Swirling light patterns */}
            <path className="swirl swirl-1" d="M 50 55 Q 60 45 70 55 Q 65 65 55 65 Q 45 60 50 55" fill="none" stroke="#6B54F9" strokeWidth="2" opacity="0.7"/>
            <path className="swirl swirl-2" d="M 50 55 Q 40 45 30 55 Q 35 65 45 65 Q 55 60 50 55" fill="none" stroke="#8B5CF6" strokeWidth="2" opacity="0.6"/>
            <path className="swirl swirl-3" d="M 50 55 Q 65 40 80 55 Q 75 70 60 70 Q 45 65 50 55" fill="none" stroke="#A855F7" strokeWidth="2" opacity="0.5"/>
            <path className="swirl swirl-4" d="M 50 55 Q 35 40 20 55 Q 25 70 40 70 Q 55 65 50 55" fill="none" stroke="#C084FC" strokeWidth="2" opacity="0.5"/>
            
            {/* Additional flowing patterns */}
            <path className="flow flow-1" d="M 50 55 Q 70 50 75 60 Q 70 70 50 65" fill="none" stroke="#6B54F9" strokeWidth="1.5" opacity="0.4"/>
            <path className="flow flow-2" d="M 50 55 Q 30 50 25 60 Q 30 70 50 65" fill="none" stroke="#A855F7" strokeWidth="1.5" opacity="0.4"/>
            
            {/* Subtle inner glow */}
            <circle className="inner-glow" cx="50" cy="50" r="25" fill="none" stroke="#6B54F9" strokeWidth="0.5" opacity="0.3"/>
          </g>
        </svg>
      </div>
      <div className="loading-text">{message}</div>
    </div>
  );
}

export default React.memo(LoadMessage);
